import {
  Button,
  ButtonProps,
  Conditional,
  ScrollSpyProps,
} from '@payaca/ambrosia';
import { FC, PropsWithChildren } from 'react';

import EnaFormLayout from '@/ui/components/enaForms/EnaFormLayout';

export interface Props {
  sections: ScrollSpyProps['sections'];
  submitProps?: ButtonProps;
}

const CommissioningLayout: FC<PropsWithChildren<Props>> = (props) => {
  const { sections, submitProps, children } = props;

  const header = (
    <>
      <h1>Commissioning information</h1>

      <Conditional condition={!!submitProps}>
        <Button type="submit" className="ml-auto" size={'sm'} {...submitProps}>
          Submit
        </Button>
      </Conditional>
    </>
  );

  return (
    <EnaFormLayout sections={sections} header={header}>
      {children}
    </EnaFormLayout>
  );
};

export default CommissioningLayout;
